import React from "react";
import classes from "../../styles/Gallery.module.css";
import GalleryImage from "./GalleryImage";
import GalleryVideo from "./GalleryVideo";
import { baseURL } from "../../../../assets/constants/baseUrl";
import PlaceHolder from "../../../../assets/images/background/splash.png";

const imageExtensions = ["jpg", "jpeg", "png", "gif"];

const GalleryElMedia = ({ media, handleSelect }) => {
  const extension = media.name.split(".").pop().toLowerCase();

  return (
    <div className={classes.GalleryElMedia}>
      {imageExtensions.includes(extension) ? (
        <GalleryImage
          src={`${baseURL}file/get/512-${media.name}?thumbnail=true`}
          handleClick={() => handleSelect("img")}
        />
      ) : (
        <GalleryVideo
          preview={PlaceHolder}
          src={`${baseURL}file/get/${media.name}`}
          handleClick={() => handleSelect("vidio")}
        />
      )}
    </div>
  );
};

export default GalleryElMedia;
